<template>
  <div id="app" class="">

    <header class="hero-curve-wrapper row-eq-height text-align-left greyDark_txt">
      <div class="content-header hero-height--xshort hero-curve-wrapper row-eq-height">
        <div class="hero-image-left header-image hero-cover"></div>

        <div class="hero-content-with-image">
          <div class="vertical-align-parent full-height">
            <div class="hero-content vertical-align-child padding-top-2 padding-bottom-2">
              <div v-if="currentRoute === '/employee-turnover'">
                <h1 class="h1-alt">Employee Turnover Cost Calculator</h1>
              </div>
              <div v-else>
                <h1 class="h1-alt">Calculate your return on modern&nbsp;learning</h1>
                <p>Build a business case to show how world-class learning can benefit your&nbsp;organization. </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="clear-fix"></div>
    </header>

    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  computed: {
    currentRoute() {
      return this.$route.path;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue